import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Layout from '../components/Layout';
import { useFetchPhotoGallery } from '../hooks/useAppInit';
import LineSeperator from '../components/ui/LineSeperator';
import img1 from '../assets/SchoolBuilding.jpg';
import img2 from '../assets/SchoolEvent.jpg';
import img3 from '../assets/SchoolEventAudi.jpg';
import img4 from '../assets/SchoolEventOthr.jpg';
import '../stylings/SingleGalleryAlbum.css';

const fallbackImages = [img1, img2, img3, img4, img1, img2, img3, img4];

export default function SingleGalleryAlbum() {
  useFetchPhotoGallery();
  const { galleryId } = useParams();
  const albums = useSelector((state) => state.photoGallery.albums);
  const album = albums.find((a) => a._id === galleryId);
  const [lightboxImg, setLightboxImg] = useState(null);

  const images = album?.images?.length ? album.images : fallbackImages;
  const title = album?.title || 'Gallery Album';

  return (
    <Layout bannerTitle={title}>
      <section className="inner-page-section">
        <div className="container-fluid px-5">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <LineSeperator title={title} />
            <Link to="/galleryall" className="back-btn">
              <i className="fas fa-arrow-left me-1"></i> Back to Gallery
            </Link>
          </div>
          <div className="row g-3">
            {images.map((img, i) => (
              <div key={i} className="col-lg-3 col-md-4 col-sm-6">
                <div className="album-img-card" onClick={() => setLightboxImg(img)}>
                  <img src={img} alt={`${title} ${i + 1}`} className="album-img" />
                  <div className="album-img-overlay"><i className="fas fa-expand"></i></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {lightboxImg && (
        <div className="lightbox-overlay" onClick={() => setLightboxImg(null)}>
          <button className="lightbox-close"><i className="fas fa-times"></i></button>
          <img src={lightboxImg} alt="Lightbox" className="lightbox-img" />
        </div>
      )}
    </Layout>
  );
}
